import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

let tabDetalhe = document.getElementsByClassName("tabDetalhe");
if (tabDetalhe.length > 0) {
    $(".tabDetalhe").on("click", function () {
        // $('.tabDetalhe').removeClass('showAba');
        let conteudo = $(this).data("tab");
        // $('.conteudo').slideUp();
        if ($(this).hasClass("showAba")) {
            $(".tabDetalhe").removeClass("showAba");
            $("#" + conteudo + " .conteudo").slideUp();
        } else {
            $(this).addClass("showAba");
            $("#" + conteudo + " .conteudo").slideDown();
        }
    });
}
